import { Register } from "../components/rate-adjustment-case/Register";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
　料率調整案件登録画面
 */
const RateAdjustmentCaseRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.RATE_SETTING);

  return (
    <SpaceBetween size="l">
      <Register />
    </SpaceBetween>
  );
};

export default RateAdjustmentCaseRegister;
